import { useNavigate } from 'react-router';
import { IconButton } from '../../Common';
import { ProjectAssigneesWithUserInfoDto } from '../../../commonTypes/project.types';
import { getCurrencySymbol } from '../../../util/general';

interface MemberCardProps {
    member: ProjectAssigneesWithUserInfoDto;
    showRates: boolean;
    canEdit: boolean;
    onEdit?: (member: ProjectAssigneesWithUserInfoDto) => void;
    currency: string;
}

export const MemberCard = ({ member, showRates, canEdit, onEdit, currency }: MemberCardProps) => {
    const navigate = useNavigate();
    const fullName = `${member.givenName || ''} ${member.familyName || ''}`.trim();
    const jobTitle = member.title || 'No title set';

    const fmtRate = (rate?: number) => (rate == null ? 'Not set' : `${getCurrencySymbol(currency)}${rate.toFixed(2)}`);
    const fmtType = (x?: string) => (!x ? 'Not set' : x.charAt(0).toUpperCase() + x.slice(1).toLowerCase());

    const handleCardClick = () => {
        navigate(`/profile/${member.userSub}`);
    };

    return (
        <div className="member-card">
            <div className="member-card__header member-card__header--clickable" onClick={handleCardClick}>
                <img
                    className="member-card__avatar"
                    src={member.imageUrl || '/svg/person.svg'}
                    alt={fullName}
                    onError={e => ((e.target as HTMLImageElement).src = '/svg/person.svg')}
                />
                <div className="member-card__info">
                    <h4 className="member-card__name">{fullName}</h4>
                    <p className="member-card__role">{jobTitle}</p>
                </div>
                {canEdit && (
                    <IconButton
                        onClick={e => {
                            e.stopPropagation();
                            onEdit?.(member);
                        }}
                        iconUrl="/svg/pen-grey.svg"
                        iconAlt="edit"
                        variant="icon"
                        className="member-card__edit"
                    />
                )}
            </div>

            {showRates && (
                <div className="member-card__details">
                    <p className="member-card__label">Rate</p>
                    <span className="member-card__separator">/</span>
                    <p className="member-card__value">{fmtRate(member.rate)}</p>

                    <p className="member-card__label">Type</p>
                    <span className="member-card__separator">/</span>
                    <p className="member-card__value">{fmtType(member.rateType)}</p>
                </div>
            )}
        </div>
    );
};
